import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, headingFont, space } from '../../theme/tokens';

export const ItemCardBase = styled.div<{ $unavailable?: boolean; $clickable: boolean }>`
  display: flex;
  flex-direction: column;
  background: ${colors.white};
  cursor: ${({ $clickable, $unavailable }) =>
    $clickable ? ($unavailable ? 'not-allowed' : 'pointer') : 'default'};
  opacity: ${({ $unavailable }) => ($unavailable ? 0.55 : 1)};
  transition: transform 0.2s ease;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
    border-radius: 12px;
  }
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 12px;
  background: ${colors.lighterGrey};
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Placeholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.grey};
  font-family: ${bodyFont};
  font-size: 0.8125rem;
`;

export const ImageBadge = styled.span`
  position: absolute;
  top: 12px;
  left: 12px;
  background: ${colors.sale};
  color: ${colors.white};
  font-family: ${fonts.body};
  font-size: 0.6875rem;
  font-weight: ${fonts.weight.semiBold};
  padding: 4px 10px;
  border-radius: 4px;
  letter-spacing: 0.2px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  padding: ${space[4]} 0 ${space[2]};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[3]};
`;

export const Title = styled.h3`
  font-family: ${headingFont};
  font-size: 1rem;
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontPrimary};
  margin: 0;
  line-height: 1.3;
  flex: 1;
  min-width: 0;
`;

export const ActionButton = styled.button`
  font-family: ${fonts.body};
  font-size: 0.8125rem;
  font-weight: ${fonts.weight.semiBold};
  background: ${colors.fontPrimary};
  color: ${colors.white};
  border: none;
  border-radius: 20px;
  padding: 8px 20px;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s ease;
  flex-shrink: 0;

  &:hover {
    opacity: 0.85;
  }
`;

export const Meta = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  font-family: ${bodyFont};
  font-size: 0.8125rem;
  color: ${colors.fontSecondary};
`;

export const PriceRow = styled.div`
  font-family: ${bodyFont};
  font-size: 0.9375rem;
  color: ${colors.fontPrimary};
`;

export const StatusBadge = styled.span`
  display: inline-block;
  font-family: ${bodyFont};
  font-size: 0.75rem;
  font-weight: ${fonts.weight.semiBold};
  color: ${colors.fontSecondary};
  background: ${colors.lighterGrey};
  border-radius: 12px;
  padding: 2px 8px;
  align-self: flex-start;
`;
